module.exports = __webpack_public_path__ + "static/img/page_18.04ce2355.png";